import { computed } from '@nuxtjs/composition-api';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useEssentialsData = (EssentialData) => {
  const introData = computed(() => {
    if (!EssentialData.value) return null;

    const title = EssentialData.value?.description;
    const descriptionContainer =
      EssentialData.value?.headless_containers?.find(
        (container) => container.code === 'intro_producttags'
      );
    const htmlDescription = descriptionContainer?.elements?.[0]?.html_content || '';
    const helperFrame = descriptionContainer?.elements?.[0]?.plain_text || '';

    return {
      title,
      htmlDescription,
      helperFrame
    };
  });

  const seoData = computed(() => {
    const seoContainer = EssentialData.value?.headless_containers?.find(
      (container) => container.code === 'seo_plp'
    );
    return seoContainer?.elements?.[0]?.html_content;
  });

  return {
    introData,
    seoData
  };
};
